import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Crown, Heart } from "lucide-react";
import { CTA_URL } from "@/lib/copy";

export default function VIPThankYou() {
  return (
    <div className="flex min-h-[100svh] items-center justify-center bg-[var(--bg)] px-5 py-10 md:px-12">
      <div className="mx-auto w-full max-w-xl text-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, ease: [0.2, 0.9, 0.2, 1] }}
          className="flex justify-center"
          data-testid="vip-thankyou"
        >
          <div className="relative inline-flex h-16 w-16 items-center justify-center rounded-full border border-[var(--pink)]/40 bg-[var(--pink)]/10">
            <Crown className="h-7 w-7 text-[var(--pink)]" strokeWidth={2.2} />
            <span className="absolute inset-0 -z-10 animate-ping rounded-full bg-[var(--pink)]/20" />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.15, duration: 0.7, ease: [0.2, 0.9, 0.2, 1] }}
        >
          <p className="mt-8 font-mono text-[11px] uppercase tracking-super text-[var(--pink)]">
            Grupo VIP · Cadastro confirmado
          </p>
          <h1 className="mt-4 font-serif text-5xl leading-[0.9] tracking-tight text-white md:text-6xl">
            Obrigada
            <span className="italic text-[var(--pink)]">.</span>
          </h1>
          <p className="mx-auto mt-6 max-w-md font-mono text-sm leading-relaxed text-white/70">
            Você foi adicionado com sucesso ao meu grupo VIP. Em breve receberá novidades{" "}
            <Heart className="mb-1 inline h-3.5 w-3.5 fill-[var(--pink)] text-[var(--pink)]" />
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.35, duration: 0.6 }}
          className="mt-10 flex flex-col items-center gap-3"
        >
          <a
            href={CTA_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-magnetic"
            data-testid="vip-thankyou-fatalfans"
          >
            <span>Ir para o conteúdo</span>
            <ArrowUpRight className="arrow h-4 w-4" strokeWidth={2.4} />
          </a>
          <Link
            to="/"
            className="font-mono text-[10px] uppercase tracking-super text-white/50 transition hover:text-white"
            data-testid="vip-thankyou-home"
          >
            voltar para o início
          </Link>
        </motion.div>
      </div>
    </div>
  );
}
